import React, { useState, useEffect, useRef, useMemo } from "react";
import ArticleForm from "../../components/forms/JournalOverviewForm";
import {
  fetchArticleByUserId,
  updateArticle,
  fetchVolIss,
} from "../../services/apiService/articleApi";
import {
  fetchIssueById,
  fetchIssueByUserId,
  updateIssue,
} from "../../services/apiService/issueApi";
import { useSelector } from "react-redux";
import { CustomTable } from "../../components/Table";
import { FaSearch, FaTimes, FaArrowUp, FaArrowDown } from "react-icons/fa";
import Pencils from "../../assets/pencil.png";
import useToaster from "../../hooks/useToaster";
import SortDropdown from "../../components/ui/DropdownSort";
import DropdownCheckbox from "../../components/ui/DropdownCheck";
import { Popover, PopoverTrigger } from "../../components/ui/Popover";
import bookpng from "../../assets/article.png";
import { useNavigate } from "react-router-dom";
import { PageSkeletons, Spinner } from "../../components/ui/Skeleton";
import IssueDetails from "../../components/forms/NewIssueForm";
import { fetchUserForForm } from "../../services/apiService/userApi";
import Pagination from "../../components/ui/Pagination";
import FilterChips from "../../components/ui/FilterChip";
import {
  MdOutlineFilterAlt,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import DynamicFilterPopover from "../../components/ui/DynamicFilterPopover";
import DataSyncError from "../../components/edgeCases/DataSyncError";

const MyTaskTable = ({ journalName = "", setLoad }) => {
  const [articleFilters, setArticleFilters] = useState({
    searchQuery: "",
    selectedVolIss: ["All"],
    selectedJournals: ["All"],
    selectedJournalIds: [],
    tempSelectedJournals: ["All"],
    articleTypes: ["All"],
    copyediting: ["All"],
    tempArticleTypes: ["All"],
    tempCopyediting: ["All"],
  });
  const [issueFilters, setIssueFilters] = useState({
    searchQuery: "",
    selectedVolIss: ["All"],
    selectedJournals: ["All"],
    tempSelectedJournals: ["All"],
    selectedJournalIds: [],
    task: [],
    tempTask: [],
  });

  const [articleTypeOpen, setArticleTypeOpen] = useState(false);
  const [productionWorkflowOpen, setProductionWorkflowOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [lastSync, setLastSync] = useState(new Date());
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [showVolIssOptions, setShowVolIssOptions] = useState(false);
  const [showJournalOptions, setShowJournalOptions] = useState(false);
  const [showFilterPopover, setShowFilterPopover] = useState(false);
  const activeTabRef = useRef("Article");
  const [tabState, setTabState] = useState("Article");
  const [selectedTask, setSelectedTask] = useState(null);
  const [articles, setArticles] = useState([]);
  const [issues, setIssues] = useState([]);
  const [articleCount, setArticleCount] = useState(0);
  const [issueCount, setIssueCount] = useState(0);
  const [isLoadingArticles, setIsLoadingArticles] = useState(false);
  const [isLoadingIssues, setIsLoadingIssues] = useState(false);
  const [articleCurrentPage, setArticleCurrentPage] = useState(1);
  const [issueCurrentPage, setIssueCurrentPage] = useState(1);
  const [articleTotalPages, setArticleTotalPages] = useState(1);
  const [issueTotalPages, setIssueTotalPages] = useState(1);
  const [articleTotalItems, setArticleTotalItems] = useState(0);
  const [issueTotalItems, setIssueTotalItems] = useState(0);
  const [articleItemsPerPage, setArticleItemsPerPage] = useState(100);
  const [issueItemsPerPage, setIssueItemsPerPage] = useState(100);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [tempSortKey, setTempSortKey] = useState(null);
  const [tempSortDirection, setTempSortDirection] =
    useState("Sort by Ascending");
  const [selectedFieldConfig, setSelectedFieldConfiguration] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [objectUserOption, setObjectUserOption] = useState([]);
  const [loadingState, setLoadingState] = useState("spinning");
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [activeRowId, setActiveRowId] = useState(null);
  const [hasFilters, setHasFilters] = useState(false);
  let [cursor, setCursor] = useState(null);
  let [articleTypesOptions, setArticleTypesOptions] = useState([]);
  let [productionWorkflowOptions, setProductionWorkflowOptions] = useState([]);

  const searchTriggeredRef = useRef(false);
  const sortEffectRanRef = useRef(false);

  const [JournalOptions, setJournalOptions] = useState([]);
  const [IssueJournalOptions, setIssueJournalOptions] = useState([]);

  const [volIssOptions, setVolIssOptions] = useState([]);
  const [IssueVolIssOptions, setIssueVolIssOptions] = useState([]);

  const { userData, preferences, dataSyncTime } = useSelector(
    (state) => state.user
  );

  const userId = userData?.id;
  const showToast = useToaster();
  const navigate = useNavigate();

  useEffect(() => {
    activeTabRef.current = tabState;

    if (tabState === "Article") {
      setSortConfig({ key: null, direction: "asc" });
    } else if (tabState === "Issue") {
      setSortConfig({
        key: null,
        direction: "asc",
      });
    }

    sortEffectRanRef.current = true;
  }, [tabState]);

  const headers = {
    Article: [
      { key: "journalInfo?.journalName", value: "JOURNAL" },
      { key: "pts", value: "PTS#" },
      { key: "volume", value: "VOLUME" },
      { key: "issue", value: "ISSUE" },
      { key: "em", value: "EM#" },
      { key: "pit", value: "PIT" },
      { key: "docHead", value: "DOCHEAD" },
      {
        key: "productionWorkflow",
        value: "PROD WF",
      },
      { key: "firstAuthor", value: "FIRST AU" },
      {
        key: "correspondingAuthor",
        value: "CORR AU",
      },
      { key: "speedTarget", value: "SPEED TARGET" },
      { key: "onDate", value: "ON DATE" },
      { key: "itemHoldout", value: "HOLDOUT" },
      { key: "itemFinalizing", value: "FINALIZING" },
      {
        key: "copyEditTaskComplete",
        value: "CE CLOSED",
      },
      {
        key: "auProofCorrectionsSubmitted",
        value: "AU CX REC",
      },
      {
        key: "revisedProofRequested",
        value: "RPR",
      },
      { key: "cfcTaskComplete", value: "CFC CLOSED" },
      {
        key: "revisedProofApproved",
        value: "REV OK",
      },
      {
        key: "productionNotes",
        value: "POST-ACC NOTES",
      },
      { key: "journalInfo?.team", value: "TEAM" },
    ],
    Issue: [
      { key: "journal", value: "JOURNAL" },
      { key: "volIss", value: "VOL/ISS" },
      { key: "task", value: "TASK" },
      { key: "team", value: "TEAM" },
      { key: "taskDueDate", value: "DUE DATE" },
    ],
  };

  const fetchArticlesData = async () => {
    try {
      setIsLoadingArticles(true);
      const response = await fetchArticleByUserId(userId, {
        limit: articleItemsPerPage,
        page: articleCurrentPage,
        time: "future",
        journal: articleFilters.selectedJournalIds,
        docHead: articleFilters.articleTypes,
        search: articleFilters.searchQuery.trim(),
        copyedit: articleFilters.copyediting,
        volIss: articleFilters.selectedVolIss,
        key: sortConfig.key,
        direction: sortConfig.direction,
      });

      if (!response.success) {
        showToast("Failed to load articles");
        setArticles([]);
        setArticleCount(0);
        setArticleTotalItems(0);
        setArticleTotalPages(1);
        setIssueCount(0);
        return;
      }

      if (response.success && response?.data?.data.length < 1) {
        setArticles([]);
        setArticleCount(0);
        setArticleTotalItems(0);
        setArticleTotalPages(1);
        setIssueCount(response?.data?.issuesCount || 0);
        return;
      }

      const { pagination, data, issuesCount } = response?.data;
      const mapped = data.map((article) => ({
        ...article,
        hasChanges:
          Array.isArray(article.changes) &&
          article.changes.some(
            (change) =>
              change.key &&
              change.previousValue !== null &&
              hasChangesArray.includes(change.key)
          ),
        type: "Article",
      }));

      setArticles(mapped);
      setIssueCount(issuesCount);
      setArticleCount(pagination.totalItems);
      setArticleTotalItems(pagination.totalItems);
      setArticleTotalPages(pagination.totalPages);
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setIsLoadingArticles(false);
    }
  };

  const fetchIssuesData = async () => {
    try {
      setIsLoadingIssues(true);
      const response = await fetchIssueByUserId(userId, {
        limit: issueItemsPerPage,
        page: issueCurrentPage,
        time: "future",
        journal: issueFilters.selectedJournalIds,
        task: issueFilters.task,
        search: issueFilters.searchQuery.trim(),
        volIss: issueFilters.selectedVolIss,
        key: sortConfig?.key,
        direction: sortConfig?.direction,
      });

      if (!response.success) {
        showToast("Failed to load Issues");
        setIssues([]);
        setIssueCount(0);
        setIssueTotalItems(0);
        setIssueTotalPages(1);
        return;
      }

      if (response.success && response?.data?.data.length < 1) {
        setIssues([]);
        setIssueCount(0);
        setIssueTotalItems(0);
        setIssueTotalPages(1);
        return;
      }

      const { pagination, data, nextCursor } = response.data;

      setIssues(data);
      setIssueCount(pagination.totalItems);
      setIssueTotalItems(pagination.totalItems);
      setIssueTotalPages(pagination.totalPages);
      setCursor(nextCursor);
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setIsLoadingIssues(false);
    }
  };

  const loadAllData = async () => {
    let success = false;
    const startTime = Date.now();

    if (!hasLoadedOnce) {
      setLoad(false);
      setLoadingState("spinning");
    }

    try {
      await fetchArticlesData();
      sortEffectRanRef.current = true;
      success = true;
    } catch (err) {
      console.log("err: ", err);
    } finally {
      if (!hasLoadedOnce) {
        const timeTaken = Date.now() - startTime;
        if (timeTaken < 2000) {
          setLoadingState("data");
          setHasLoadedOnce(true);
          setLoad(false);
        } else if (timeTaken < 5000) {
          setTimeout(() => {
            setLoadingState("data");
            setHasLoadedOnce(true);
            setLoad(false);
          }, 2000);
        } else {
          setTimeout(() => {
            setLoadingState("skeleton");
            setLoad(true);
            setTimeout(() => {
              setLoadingState("data");
              setLoad(false);
              if (success) setHasLoadedOnce(true);
            }, 2000);
          }, 3000);
        }
      }
    }
  };

  // initial load
  useEffect(() => {
    loadAllData();
  }, []);

  //fetch for filters
  useEffect(() => {
    if (!sortEffectRanRef.current) return;
    if (!userData) return;
    if (activeTabRef.current === "Issue") {
      fetchIssuesData();
    } else {
      fetchArticlesData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    articleCurrentPage,
    issueCurrentPage,
    articleItemsPerPage,
    issueItemsPerPage,
    articleFilters.selectedJournalIds,
    articleFilters.selectedJournals,
    articleFilters.articleTypes,
    articleFilters.copyediting,
    articleFilters.selectedVolIss,
    issueFilters.selectedJournalIds,
    issueFilters.task,
    issueFilters.selectedVolIss,
    sortConfig,
    userData,
    preferences,
  ]);

  const fetchDataOnSearch = () => {
    if (!searchTriggeredRef.current) return;
    if (
      (articleFilters.searchQuery.trim().length > 2 ||
        !articleFilters.searchQuery.trim().length) &&
      activeTabRef.current === "Article"
    ) {
      setArticleCurrentPage(1);
      fetchArticlesData();
    } else if (
      (issueFilters.searchQuery.trim().length > 2 ||
        !issueFilters.searchQuery.trim().length) &&
      activeTabRef.current === "Issue"
    ) {
      setIssueCurrentPage(1);
      fetchIssuesData();
    }
  };

  // fetch for search
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchDataOnSearch();
    }, 600);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleFilters.searchQuery, issueFilters.searchQuery]);

  const isInitialLoading = useMemo(() => {
    if (activeTabRef.current === "Article") {
      return articles.length === 0 && isLoadingArticles;
    }
    return issues.length === 0 && isLoadingIssues;
  }, [articles, isLoadingArticles, issues, isLoadingIssues, activeTabRef]);

  const fetchUsersList = async () => {
    const response = await fetchUserForForm();
    if (response.success) {
      const { userNames, userOptions } = response?.data;
      setUserOption(userNames);
      setObjectUserOption(userOptions);
    }
  };

  let fetchVolIssOptions = async () => {
    try {
      let response = await fetchVolIss({
        id: userData.id,
        type: activeTabRef.current === "Article" ? "Article" : "Issue",
        time: "future",
        journal: "",
        place: "myTask",
      });
      if (activeTabRef.current === "Article") {
        setVolIssOptions(response.data.data.volIss);
        setProductionWorkflowOptions(response?.data?.data?.productionWorkflow);
        setArticleTypesOptions(response?.data?.data?.docHead);
        setJournalOptions(response?.data?.data?.journalId);
      } else {
        setIssueJournalOptions(response?.data?.data?.journalId);
        setIssueVolIssOptions(response.data.data.volIss);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVolIssOptions();
  }, [tabState]);

  useEffect(() => {
    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    }
  }, [activeTabRef.current, tabState]);

  const hasChangesArray = [
    "issue",
    "volume",
    // "productionWorkflow",
    // "handlingEditor",
    // "dateBackFromSce",
    // "sceReturnedStatus",
  ];

  useEffect(() => {
    setCursor(null);
  }, [
    issueFilters.searchQuery,
    issueFilters.selectedJournalIds,
    issueFilters.task,
    issueFilters.selectedVolIss,
    activeTabRef,
  ]);

  const getFilterLabel = (selectedItems, defaultLabel, options = []) => {
    if (selectedItems?.includes("All") || selectedItems?.length === 0) {
      return `${defaultLabel}: All`;
    }
    const selectedLabels = selectedItems?.map((item) => {
      const option = options?.find((opt) => opt?.value === item);
      return option?.label ?? item;
    });
    return selectedLabels?.length === 1
      ? `${defaultLabel}: ${selectedLabels?.[0]}`
      : `${defaultLabel}: ${selectedLabels?.[0]} + more`;
  };

  const taskActions = (row) => (
    <div
      className="flex items-center justify-center p-2 text-sm rounded-lg text-[#1C40C9] cursor-pointer hover:bg-blue-300"
      onClick={() => handleEditClick(row)}
    >
      <img
        src={Pencils}
        alt="Edit"
        className="max-w-4 min-w-2 max-h-4 min-h-2"
      />
    </div>
  );

  const handleEditClick = async (task) => {
    try {
      let newTask = task;
      if (activeTabRef.current === "Issue") {
        let issue = await fetchIssueById(task.id);
        if (issue.success && issue?.data) {
          newTask = issue?.data;
          setSelectedFieldConfiguration(
            newTask?.ArticleDetails?.[0]?.journalInfo?.fieldConfiguration
          );
        }
      } else {
        setSelectedFieldConfiguration(task?.journalInfo?.fieldConfiguration);
      }
      setSelectedTask(newTask);
      await fetchUsersList();
    } catch (error) {
      showToast(error.message ?? "Something went wrong");
    }
  };

  const handleUpdateTask = async (updatedTask) => {
    try {
      const isArticle = activeTabRef.current === "Article";
      let taskData = { ...updatedTask };

      if (isArticle) {
        if (typeof taskData.points === "string") {
          const parsed = Number(taskData.points);
          taskData.points = isNaN(parsed) ? null : parsed;
        }
      }
      const apiFunction = isArticle ? updateArticle : updateIssue;
      const response = await apiFunction(taskData.id, taskData);

      if (response) {
        showToast("Task updated successfully");
        handleCloseForm();
      } else {
        showToast(response.message || "Failed to update task");
      }
    } catch (error) {
      console.error("Error updating task:", error);
      showToast("Error updating task: " + error.message);
    } finally {
      if (activeTabRef.current === "Issue") {
        await fetchIssuesData();
      } else {
        await fetchArticlesData();
      }
    }
  };

  const handleCloseForm = () => {
    setSelectedTask(null);
    setActiveRowId(null);
  };

  const handlePageChange = (page) => {
    if (activeTabRef.current === "Article") {
      if (page >= 1 && page <= articleTotalPages) {
        setArticleCurrentPage(page);
      }
    } else {
      if (page > 1) {
        setIssueCurrentPage(page);
      } else if (page === 1) {
        setIssueCurrentPage(page);
        setCursor(null);
      }
    }
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    if (activeTabRef.current === "Article") {
      setArticleItemsPerPage(newItemsPerPage);
      setArticleCurrentPage(1);
    } else {
      setIssueItemsPerPage(newItemsPerPage);
      setIssueCurrentPage(1);
    }
  };

  const handleVolIssSelection = (selected) => {
    const newSelection =
      selected.includes("All") || selected.length === 0 ? ["All"] : selected;
    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({ ...prev, selectedVolIss: newSelection }));
      setArticleCurrentPage(1);
    } else {
      setIssueFilters((prev) => ({ ...prev, selectedVolIss: newSelection }));
      setIssueCurrentPage(1);
    }
  };

  const handleJournalSelection = (selected, journals) => {
    let journalOption =
      activeTabRef.current === "Article" ? JournalOptions : IssueJournalOptions;
    const validJournals = Array.isArray(journals) ? journals : [];
    const newSelection =
      selected.includes("All") ||
      selected.length === 0 ||
      journalOption.length === selected.length
        ? ["All"]
        : selected;

    const isAllSelected =
      (Array.isArray(newSelection) &&
        newSelection.length === 1 &&
        newSelection[0] === "All") ||
      journalOption.length === selected.length;

    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        selectedJournals: newSelection,

        tempSelectedJournals: isAllSelected
          ? newSelection
          : validJournals.map((data) => data.value),
        selectedJournalIds: validJournals,
      }));
      setArticleCurrentPage(1);
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        selectedJournals: newSelection,

        tempSelectedJournals: isAllSelected
          ? newSelection
          : validJournals.map((data) => data.value),
        selectedJournalIds: validJournals,
      }));
      setIssueCurrentPage(1);
    }
  };

  const handleTempArticleTypeChange = (type) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempArticleTypes: type.length >= 1 ? type : ["All"],
    }));
  };

  const handleTempCopyeditingChange = (copyeditingOption) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempCopyediting:
        copyeditingOption.length >= 1 ? copyeditingOption : ["All"],
    }));
  };

  const handleTempTaskChange = (task) => {
    setIssueFilters((prev) => ({
      ...prev,
      tempTask: task,
      //   prev.tempTask.includes(task)
      //     ? prev.tempTask.filter((t) => t !== task)
      //     : [...prev.tempTask, task],
    }));
  };

  const applyFilters = () => {
    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        articleTypes: [...prev.tempArticleTypes],
        copyediting: [...prev.tempCopyediting],
      }));
      setArticleCurrentPage(1);
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        task: [...prev.tempTask],
      }));
      setIssueCurrentPage(1);
    }
    setShowFilterPopover(false);
    // setHasFilters(true);
  };

  const handleClearFilters = () => {
    if (activeTabRef.current === "Article") {
      setArticleFilters({
        searchQuery: "",
        selectedVolIss: ["All"],
        selectedJournals: ["All"],
        selectedJournalIds: [],
        articleTypes: ["All"],
        copyediting: ["All"],
        tempArticleTypes: ["All"],
        tempSelectedJournals: ["All"],
        tempCopyediting: ["All"],
      });
      setArticleCurrentPage(1);
    } else {
      setIssueFilters({
        searchQuery: "",
        selectedVolIss: ["All"],
        selectedJournals: ["All"],
        selectedJournalIds: [],
        tempSelectedJournals: ["All"],
        task: [],
        tempTask: [],
      });
      setIssueCurrentPage(1);
    }
    setHasFilters(false);
    setCursor(null);
  };

  const handleAdvancedClearFilter = () => {
    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        tempArticleTypes: ["All"],
        tempCopyediting: ["All"],
      }));
      setArticleCurrentPage(1);
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        tempTask: [],
      }));
      setIssueCurrentPage(1);
    }
    setHasFilters(false);
    setCursor(null);
  };

  const isNoTasks =
    activeTabRef.current === "Article" ? articleCount === 0 : issueCount === 0;

  useEffect(() => {
    const hasArticleFilters =
      (articleFilters.copyediting.length > 0 &&
        !articleFilters.copyediting.includes("All")) ||
      (articleFilters.articleTypes.length > 0 &&
        !articleFilters.articleTypes.includes("All"));
    const hasIssueFilters = issueFilters.task.length > 0;
    setHasFilters(
      activeTabRef.current === "Article" ? hasArticleFilters : hasIssueFilters
    );
  }, [articleFilters, issueFilters, tabState]);

  const ArticleSections = [
    {
      label: "Dochead",
      key: "articleType",
      values: articleTypesOptions,
    },
    {
      label: "Production workflow",
      key: "productionWorkflow",
      values: productionWorkflowOptions,
    },
  ];

  const IssueSection = [
    {
      label: "Task",
      key: "task",
      values: [
        { value: "coverHandler", label: "Cover handling" },
        { value: "tocHandler", label: "TOC handling" },
        { value: "webHandler", label: "Web handling" },
        { value: "finalizingHandler", label: "Finalizing handling" },
      ],
    },
  ];

  const ArticleTempValues = {
    articleType: articleFilters.tempArticleTypes,
    productionWorkflow: articleFilters.tempCopyediting,
  };

  const ArticleTempSetValues = {
    articleType: handleTempArticleTypeChange,
    productionWorkflow: handleTempCopyeditingChange,
  };

  const IssueTempValues = {
    task: issueFilters.tempTask,
  };

  const IssueSetTempValues = {
    task: handleTempTaskChange,
  };

  const sections =
    activeTabRef.current === "Article" ? ArticleSections : IssueSection;
  const tempSelected =
    activeTabRef.current === "Article" ? ArticleTempValues : IssueTempValues;
  const setTempSelected =
    activeTabRef.current === "Article"
      ? ArticleTempSetValues
      : IssueSetTempValues;

  const isSearchEmpty = useMemo(() => {
    return activeTabRef.current === "Article"
      ? articleFilters.searchQuery.trim().length < 1
      : issueFilters.searchQuery.trim().length < 1;
  }, [articleFilters, issueFilters, activeTabRef.current]);

  return loadingState === "spinning" ? (
    <div
      className="flex justify-center items-center w-full"
      style={{ minHeight: "calc(100vh - 72px)" }}
    >
      <Spinner />
    </div>
  ) : loadingState === "skeleton" ? (
    <PageSkeletons
      hasTabs={true}
      hasButton={false}
      hasSearch={true}
      hasSortOptions={true}
      sortOptionCount={4}
      tableColumnCount={activeTabRef.current === "Article" ? 14 : 5}
      tableRowCount={8}
      hasRightHeader={true}
      leftWidth="w-[100px]"
    />
  ) : (
    <div
      className="bg-gray-100 flex flex-col"
      style={{
        fontFamily: "Source Sans Pro, sans-serif",
        height: "calc(100vh - 72px)",
      }}
    >
      <div className="flex-1 pt-6 px-6 bg-white flex flex-col h-full">
        <>
          {!selectedTask && (
            <div className="header-section shrink-0 bg-white sticky top-0 z-10">
              {/* Bread */}
              <div className="flex items-center justify-start mb-3 space-x-1">
                <p className="text-[#868E94] font-medium text-[13px]">
                  My Tasks
                </p>{" "}
                <MdOutlineKeyboardArrowRight className="text-[#5D6871] text-[16px]" />{" "}
                <p className="text-[#5D6871] font-medium text-[13px]">
                  {activeTabRef.current}
                </p>
              </div>
              {/* Title */}
              <div className="flex items-center justify-between mb-2">
                <h1 className="text-[#20282E] text-[23px] h-[32px] font-semibold">
                  My Tasks
                </h1>
                <span className="text-[11px] h-[14px] w-[165px] text-[#35424D] font-medium flex items-center">
                  <DataSyncError />
                  Last Sync: {dataSyncTime?.value}
                  <br></br>
                  {/* {dataSyncTime?.value ? "Snowflake data not available." : ""} */}
                </span>
              </div>
              {/* Tabs */}
              <div className="flex items-center justify-between border-b-2 border-gray-200 mb-3">
                <div className="flex">
                  <button
                    className={`p-3 flex items-center h-[28px] ${
                      activeTabRef.current === "Article"
                        ? "border-b-2 border-[#1C40C9] text-[13px] text-[#35424D] font-semibold"
                        : "font-medium hover:text-[#35424D] text-[13px]"
                    }`}
                    onClick={() => {
                      activeTabRef.current = "Article";
                      setTabState("Article");
                      setCursor(null);
                    }}
                  >
                    Article ({articleCount})
                  </button>
                  <button
                    className={`p-3 flex items-center h-[28px] ${
                      activeTabRef.current === "Issue"
                        ? "border-b-2 border-[#1C40C9] text-[13px] text-[#35424D] font-semibold"
                        : "font-medium hover:text-[#35424D] text-[13px]"
                    }`}
                    onClick={() => {
                      activeTabRef.current = "Issue";
                      setTabState("Issue");
                      setCursor(null);
                    }}
                  >
                    Issue ({issueCount})
                  </button>
                </div>
              </div>
              {/* Search Bar */}
              <div className="flex items-center justify-between mb-4">
                <div className="relative w-[246px]">
                  <input
                    type="text"
                    className={`border rounded-[4px] w-[246px] h-[32px] py-[4px] px-[12px] pr-[32px] text-sm transition-colors ${
                      isFocused
                        ? " focus:border-[#35424D] focus:border focus:outline-none"
                        : "border-[#C3C3C3]"
                    }`}
                    placeholder="Search"
                    maxLength={100}
                    value={
                      activeTabRef.current === "Article"
                        ? articleFilters.searchQuery
                        : issueFilters.searchQuery
                    }
                    onChange={(e) => {
                      if (activeTabRef.current === "Article") {
                        setArticleFilters((prev) => ({
                          ...prev,
                          searchQuery: e.target.value,
                        }));
                        searchTriggeredRef.current = true;
                      } else {
                        setIssueFilters((prev) => ({
                          ...prev,
                          searchQuery: e.target.value,
                        }));
                        searchTriggeredRef.current = true;
                      }
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() =>
                      (activeTabRef.current === "Article"
                        ? articleFilters.searchQuery === ""
                        : issueFilters.searchQuery === "") &&
                      setIsFocused(false)
                    }
                  />
                  {(!isFocused ||
                    (activeTabRef.current === "Article"
                      ? articleFilters.searchQuery.length === 0
                      : issueFilters.searchQuery.length === 0)) && (
                    <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3]" />
                  )}
                  {((activeTabRef.current === "Article" &&
                    articleFilters.searchQuery.length > 0) ||
                    (activeTabRef.current === "Issue" &&
                      issueFilters.searchQuery.length > 0)) && (
                    <FaTimes
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] cursor-pointer"
                      onClick={() => {
                        if (activeTabRef.current === "Article") {
                          setArticleFilters((prev) => ({
                            ...prev,
                            searchQuery: "",
                          }));
                          setIsLoadingArticles(true);
                        } else {
                          setIssueFilters((prev) => ({
                            ...prev,
                            searchQuery: "",
                          }));
                          setIsLoadingIssues(true);
                        }
                      }}
                    />
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <Popover
                    open={showSortOptions}
                    onOpenChange={setShowSortOptions}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          showSortOptions ? "bg-[#D9D9D9]" : ""
                        }`}
                      >
                        <span className="text-[#35424D] font-semibold text-[13px] flex items-center gap-1">
                          Sort by:
                          <span className="flex items-center font-medium gap-1">
                            {sortConfig.direction === "asc" ? (
                              <FaArrowUp className="text-[#35424D] h-[12px]" />
                            ) : sortConfig.direction === "desc" ? (
                              <FaArrowDown className="text-[#35424D] h-[12px]" />
                            ) : null}
                            {(() => {
                              const header =
                                activeTabRef.current === "Article"
                                  ? headers["Article"]
                                  : headers["Issue"];

                              if (!sortConfig.key) return "";

                              const match = header?.find((h) => {
                                const headerKeyLast = h.key.includes(".")
                                  ? h.key.split(".").pop()
                                  : h.key;
                                const sortKeyLast = sortConfig.key.includes(".")
                                  ? sortConfig.key.split(".").pop()
                                  : sortConfig.key;
                                return headerKeyLast === sortKeyLast;
                              });

                              return match?.value || "";
                            })()}
                          </span>
                        </span>
                        <i
                          className={`fas fa-chevron-down text-[#35424D] text-[14px] ${
                            showSortOptions ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                    </PopoverTrigger>
                    <SortDropdown
                      headers={headers[activeTabRef.current]}
                      activeTab={tabState}
                      isOpen={showSortOptions}
                      sortConfig={sortConfig}
                      setSortConfig={setSortConfig}
                      tempSortKey={tempSortKey}
                      setTempSortKey={setTempSortKey}
                      tempSortDirection={tempSortDirection}
                      setTempSortDirection={setTempSortDirection}
                      setShowSortOptions={setShowSortOptions}
                      setClientPagination={() =>
                        activeTabRef.current === "Article"
                          ? setArticleCurrentPage(1)
                          : setIssueCurrentPage(1)
                      }
                    />
                  </Popover>

                  {/* {activeTabRef.current === "Issue" && (
                    <Popover
                      open={showVolIssOptions}
                      onOpenChange={(open) => {
                        // For remove temp selection
                        if (!open) {
                          setVolIssOptions((prev) => [...prev]);
                        }
                        setShowVolIssOptions(open);
                      }}
                    >
                      <PopoverTrigger asChild>
                        <button
                          className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                            showVolIssOptions ? "bg-[#D9D9D9]" : ""
                          }`}
                        >
                          <span className="text-[#35424D] text-[13px]">
                            <span className="font-semibold">Vol/Iss:</span>{" "}
                            <span className="font-medium">
                              {(activeTabRef.current === "Article"
                                ? articleFilters.selectedVolIss
                                : issueFilters.selectedVolIss
                              ).includes("All")
                                ? "All"
                                : `${
                                    (activeTabRef.current === "Article"
                                      ? articleFilters.selectedVolIss
                                      : issueFilters.selectedVolIss)[0]
                                  } ${
                                    (activeTabRef.current === "Article"
                                      ? articleFilters.selectedVolIss
                                      : issueFilters.selectedVolIss
                                    ).length > 1
                                      ? " + more"
                                      : ""
                                  }`}
                            </span>
                          </span>
                          <i
                            className={`fas fa-chevron-down text-xs ${
                              showVolIssOptions ? "rotate-180" : ""
                            }`}
                          />
                        </button>
                      </PopoverTrigger>
                      <DropdownCheckbox
                        options={
                          activeTabRef.current === "Article"
                            ? volIssOptions
                            : IssueVolIssOptions
                        }
                        selectedValues={
                          activeTabRef.current === "Article"
                            ? articleFilters.selectedVolIss
                            : issueFilters.selectedVolIss
                        }
                        onSelectionChange={handleVolIssSelection}
                        selectAllText="All"
                        clearAllText="Clear all"
                        applyText="Apply"
                        searchPlaceholder="Search vol/Iss..."
                        onClose={() => setShowVolIssOptions(false)}
                      />
                    </Popover>
                  )} */}

                  <Popover
                    open={showJournalOptions}
                    onOpenChange={(open) => {
                      // for remove temp selection
                      if (!open) {
                        setJournalOptions((prev) => [...prev]);
                      }
                      setShowJournalOptions(open);
                    }}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          showJournalOptions ? "bg-[#D9D9D9]" : ""
                        }`}
                      >
                        <span className="text-[#35424D] text-[13px]">
                          <span className="font-semibold">Journal</span>{" "}
                          <span className="font-medium">
                            {getFilterLabel(
                              activeTabRef.current === "Article"
                                ? articleFilters.selectedJournals
                                : issueFilters.selectedJournals,
                              "",
                              JournalOptions
                            ).replace(/^Journal:\s*/, "")}
                          </span>
                        </span>
                        <i
                          className={`fas fa-chevron-down text-xs ${
                            showJournalOptions ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                    </PopoverTrigger>
                    <DropdownCheckbox
                      options={
                        activeTabRef.current === "Article"
                          ? JournalOptions
                          : IssueJournalOptions
                      }
                      selectedValues={
                        activeTabRef.current === "Article"
                          ? articleFilters.tempSelectedJournals
                          : issueFilters.tempSelectedJournals
                      }
                      onSelectionChange={handleJournalSelection}
                      selectAllText="All"
                      clearAllText="Clear all"
                      applyText="Apply"
                      type="Journal"
                      isOpen={showJournalOptions}
                      label={true}
                      searchPlaceholder="Search journals..."
                      onClose={() => setShowJournalOptions(false)}
                      SetSelectedValuesId={
                        activeTabRef.current === "Article"
                          ? (ids) =>
                              setArticleFilters((prev) => ({
                                ...prev,
                                tempSelectedJournals:
                                  ids.length >= 1 &&
                                  JournalOptions.length !== ids.length
                                    ? ids?.map((id) => id?.value)
                                    : ["All"],
                                selectedJournalIds:
                                  ids.length >= 1 &&
                                  JournalOptions.length !== ids.length
                                    ? ids
                                    : [],
                              }))
                          : (ids) =>
                              setIssueFilters((prev) => ({
                                ...prev,
                                tempSelectedJournals:
                                  ids.length >= 1 &&
                                  IssueJournalOptions.length !== ids.length
                                    ? ids?.map((id) => id?.value)
                                    : ["All"],
                                selectedJournalIds:
                                  ids.length >= 1 &&
                                  IssueJournalOptions.length !== ids.length
                                    ? ids
                                    : [],
                              }))
                      }
                    />
                  </Popover>
                  {activeTabRef.current === "Issue" && (
                    <Popover
                      open={showFilterPopover}
                      onOpenChange={(open) => {
                        setShowFilterPopover(open);
                        if (!open) {
                          // Reset nested popover states when main popover closes
                          setArticleTypeOpen(false);
                          setProductionWorkflowOpen(false);
                        }
                        if (open) {
                          if (activeTabRef.current === "Article") {
                            setArticleFilters((prev) => ({
                              ...prev,
                              tempArticleTypes: [...prev.articleTypes],
                              tempCopyediting: [...prev.copyediting],
                            }));
                          } else {
                            setIssueFilters((prev) => ({
                              ...prev,
                              tempTask: [...prev.task],
                            }));
                          }
                        }
                      }}
                    >
                      <PopoverTrigger asChild>
                        <button
                          className={`flex items-center justify-center p-2 w-[32px] h-[32px] rounded-md hover:bg-[#E1E6FF] ${
                            showFilterPopover
                              ? "border-[#1C40C9] bg-[#B8C7FF] hover:bg-[#E1E6FF]"
                              : ""
                          }`}
                        >
                          <div className="relative">
                            <MdOutlineFilterAlt className="text-[#1C40C9] h-[15px] w-[15px]" />
                            {hasFilters && (
                              <span className="absolute top-[-2px] right-[-2px] h-[6px] w-[6px] bg-red-500 rounded-full" />
                            )}
                          </div>
                        </button>
                      </PopoverTrigger>
                      <DynamicFilterPopover
                        sections={sections}
                        tempSelected={tempSelected}
                        setTempSelected={setTempSelected}
                        clearAllFilters={handleAdvancedClearFilter}
                        applyFilters={applyFilters}
                        type={
                          activeTabRef.current === "Article"
                            ? "Article"
                            : "Issue"
                        }
                        articleTypeOpen={articleTypeOpen}
                        setArticleTypeOpen={setArticleTypeOpen}
                        productionWorkflowOpen={productionWorkflowOpen}
                        setProductionWorkflowOpen={setProductionWorkflowOpen}
                      />
                    </Popover>
                  )}
                </div>
              </div>

              {(activeTabRef.current === "Article"
                ? articleFilters.searchQuery.length >= 3
                : issueFilters.searchQuery.length >= 3) && (
                <p className="mt-1 mb-4 text-sm text-gray-600">
                  Showing search results:{" "}
                  <span className="text-black italic">
                    '
                    {activeTabRef.current === "Article"
                      ? articleFilters.searchQuery
                      : issueFilters.searchQuery}
                    '
                  </span>
                </p>
              )}
              {(articleFilters.searchQuery.trim() ||
                issueFilters.searchQuery.trim() ||
                (activeTabRef.current === "Article"
                  ? !articleFilters.selectedVolIss.includes("All")
                  : !issueFilters.selectedVolIss.includes("All")) ||
                (activeTabRef.current === "Article"
                  ? !articleFilters.selectedJournals.includes("All")
                  : !issueFilters.selectedJournals.includes("All")) ||
                (activeTabRef.current === "Article"
                  ? articleFilters.articleTypes.length > 0 ||
                    articleFilters.copyediting.length > 0
                  : issueFilters.task.length > 0)) && (
                <FilterChips
                  filters={{
                    searchTerm:
                      activeTabRef.current === "Article"
                        ? articleFilters.searchQuery.trim() || null
                        : issueFilters.searchQuery.trim() || null,
                    selectedVolIss:
                      activeTabRef.current === "Article"
                        ? articleFilters.selectedVolIss.includes("All")
                          ? null
                          : articleFilters.selectedVolIss
                        : issueFilters.selectedVolIss.includes("All")
                        ? null
                        : issueFilters.selectedVolIss,
                    selectedJournals:
                      activeTabRef.current === "Article"
                        ? articleFilters.selectedJournals.includes("All")
                          ? null
                          : articleFilters.selectedJournals
                        : issueFilters.selectedJournals.includes("All")
                        ? null
                        : issueFilters.selectedJournals,
                    selectedArticleTypes:
                      activeTabRef.current === "Article" &&
                      articleFilters.articleTypes.length > 0
                        ? articleFilters.articleTypes
                        : null,
                    selectedCopyediting:
                      activeTabRef.current === "Article" &&
                      articleFilters.copyediting.length > 0
                        ? articleFilters.copyediting
                        : null,
                    selectedTask:
                      activeTabRef.current === "Issue" &&
                      issueFilters.task.length > 0
                        ? issueFilters.task
                        : null,
                  }}
                  onRemoveFilter={(filterKey, value) => {
                    // eslint-disable-next-line default-case
                    switch (filterKey) {
                      case "searchTerm":
                        if (activeTabRef.current === "Article") {
                          setArticleFilters((prev) => ({
                            ...prev,
                            searchQuery: "",
                          }));
                          setArticleCurrentPage(1);
                        } else {
                          setIssueFilters((prev) => ({
                            ...prev,
                            searchQuery: "",
                          }));
                          setIssueCurrentPage(1);
                        }
                        break;
                      case "selectedVolIss":
                        handleVolIssSelection(
                          (activeTabRef.current === "Article"
                            ? articleFilters.selectedVolIss
                            : issueFilters.selectedVolIss
                          ).filter((v) => v !== value)
                        );
                        break;
                      case "selectedJournals":
                        const currentJournals =
                          activeTabRef.current === "Article"
                            ? articleFilters.selectedJournals
                            : issueFilters.selectedJournals;
                        const currentJournalIds =
                          activeTabRef.current === "Article"
                            ? articleFilters.selectedJournalIds
                            : issueFilters.selectedJournalIds;
                        handleJournalSelection(
                          currentJournals.filter((j) => j !== value),
                          currentJournalIds.filter((j) => j.label !== value)
                        );
                        break;
                      case "selectedArticleTypes":
                        if (activeTabRef.current === "Article") {
                          setArticleFilters((prev) => {
                            const updated = prev.articleTypes.filter(
                              (t) => t !== value
                            );
                            return {
                              ...prev,
                              articleTypes:
                                updated.length > 0 ? updated : ["All"],
                              tempArticleTypes:
                                updated.length > 0 ? updated : ["All"],
                            };
                          });
                          setArticleCurrentPage(1);
                        }
                        break;

                      case "selectedCopyediting":
                        if (activeTabRef.current === "Article") {
                          setArticleFilters((prev) => {
                            const updated = prev.copyediting.filter(
                              (c) => c !== value
                            );
                            return {
                              ...prev,
                              copyediting:
                                updated.length > 0 ? updated : ["All"],
                              tempCopyediting:
                                updated.length > 0 ? updated : ["All"],
                            };
                          });
                          setArticleCurrentPage(1);
                        }
                        break;

                      case "selectedTask":
                        if (activeTabRef.current === "Issue") {
                          setIssueFilters((prev) => ({
                            ...prev,
                            task: prev.task.filter((t) => t !== value),
                            tempTask: prev.tempTask.filter((t) => t !== value),
                          }));
                          setIssueCurrentPage(1);
                        }
                        break;
                    }
                    setCursor(null);
                  }}
                  onClearAll={handleClearFilters}
                />
              )}
            </div>
          )}
          {selectedTask && activeTabRef.current === "Issue" && (
            <div className="flex flex-col h-full">
              <IssueDetails
                text="My Task (Issue)"
                formdata={selectedTask}
                onSave={handleUpdateTask}
                Onclose={handleCloseForm}
                fieldConfig={selectedFieldConfig}
                userOption={userOption}
                optionsMap={objectUserOption}
              />
            </div>
          )}
          {selectedTask && activeTabRef.current === "Article" && (
            <ArticleForm
              text="My Task (Article)"
              onSave={handleUpdateTask}
              onCancel={handleCloseForm}
              initialData={selectedTask}
              productionHandlers={objectUserOption}
              fieldConfiguration={selectedFieldConfig}
            />
          )}
          <div
            className={`content-section ${
              selectedTask ? "overflow-y-hidden" : "overflow-y-auto"
            } ${
              activeTabRef.current === "Article" && !selectedTask && !isNoTasks
                ? "border border-[#DCDCDC] rounded-md"
                : activeTabRef.current === "Issue" &&
                  !selectedTask &&
                  !isNoTasks
                ? "border border-[#DCDCDC] rounded-md"
                : ""
            } z-0 `}
          >
            {isNoTasks &&
            isSearchEmpty &&
            !isLoadingArticles &&
            !isLoadingIssues ? (
              <div className="flex flex-col items-center justify-center py-8">
                <img
                  src={bookpng}
                  alt="No tasks"
                  className="w-[90px] h-[90px]"
                />
                <p className="text-[#35424D] font-semibold text-lg mb-4">
                  No tasks assigned for you
                </p>
                <p className="text-[#5D6871] text-sm mb-4">
                  There are no {activeTabRef.current.toLowerCase()} tasks
                  assigned at the moment
                </p>
                <button
                  className="text-[#1C40C9] hover:text-[#1C40C9] text-[13px] font-medium"
                  onClick={() => {
                    if (
                      userData.articleTaskManagement !== "None" &&
                      userData.issueTaskManagement !== "None"
                    ) {
                      navigate("/assignment");
                    }
                  }}
                >
                  View my task assignment
                </button>
              </div>
            ) : isInitialLoading ||
              (isLoadingArticles && !articles.length) ||
              (isLoadingIssues && !issues.length) ? (
              <div className="h-[50vh]">
                <Spinner />
              </div>
            ) : (
              <div>
                {!selectedTask && (
                  <CustomTable
                    data={
                      activeTabRef.current === "Article" ? articles : issues
                    }
                    actions={taskActions}
                    searchTerm={
                      activeTabRef.current === "Article"
                        ? articleFilters.searchQuery.trim()
                        : issueFilters.searchQuery.trim()
                    }
                    setSearchTerm={(value) =>
                      activeTabRef.current === "Article"
                        ? setArticleFilters((prev) => ({
                            ...prev,
                            searchQuery: value,
                          }))
                        : setIssueFilters((prev) => ({
                            ...prev,
                            searchQuery: value,
                          }))
                    }
                    setLoading={
                      activeTabRef.current === "Article"
                        ? setIsLoadingArticles
                        : setIsLoadingIssues
                    }
                    headers={headers[activeTabRef.current]}
                    activeTab={tabState}
                    sortConfig={sortConfig}
                    setSortConfig={setSortConfig}
                    setActiveRowId={setActiveRowId}
                    activeRowId={activeRowId}
                  />
                )}
              </div>
            )}
          </div>
          {!selectedTask && !isNoTasks && (
            <div className="sticky bottom-0 mt-auto bg-white">
              <Pagination
                currentPage={
                  activeTabRef.current === "Article"
                    ? articleCurrentPage
                    : issueCurrentPage
                }
                totalPages={
                  activeTabRef.current === "Article"
                    ? articleTotalPages
                    : issueTotalPages
                }
                totalItems={
                  activeTabRef.current === "Article"
                    ? articleTotalItems
                    : issueTotalItems
                }
                itemsPerPage={
                  activeTabRef.current === "Article"
                    ? articleItemsPerPage
                    : issueItemsPerPage
                }
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default MyTaskTable;
